// extracted by mini-css-extract-plugin
export default {"container":"ModSearchBar_container__78YB8","input":"ModSearchBar_input__e7-Z4","searchIcon":"ModSearchBar_searchIcon__oK0Ge","clearBtn":"ModSearchBar_clearBtn__+OR4P"};